import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useIntl } from "react-intl";
import { Contact } from "../contact/Contact";

export const FooterQuestion = ({ contactSectionRef }) => {
  const intl = useIntl();
  return (
    <div
      className="flex items-center justify-evenly bg-neutral-100 px-[5vw] py-[8vh] text-neutral-800"
      ref={contactSectionRef}
    >
      {/* Left side - FooterQuestion content */}
      <BlockInTextCard
        tag={intl.formatMessage({ id: "footer.support" })}
        text={
          <>
            <strong>{intl.formatMessage({ id: "footer.haveQuestion" })}</strong> {intl.formatMessage({ id: "footer.loveToHelp" })}
            {intl.formatMessage({ id: "footer.anyIssue" })}
          </>
        }
        examples={[
          intl.formatMessage({ id: "footer.q1" }),
          intl.formatMessage({ id: "footer.q2" }),
          intl.formatMessage({ id: "footer.q3" }),
          intl.formatMessage({ id: "footer.q4" }),
        ]}
      />

      {/* Right side - Cards with margin to the left for spacing */}
      <div className="ml-[3vw]">
        <Contact />
      </div>
    </div>
  );
};

const BlockInTextCard = ({ tag, text, examples }) => {
  const intl = useIntl();
  return (
    <div className="w-full max-w-xl space-y-6">
      <div>
        <p className="mb-1.5 text-sm font-light uppercase">{tag}</p>
        <hr className="border-neutral-700" />
      </div>
      <p className="max-w-lg text-xl leading-relaxed">{text}</p>
      <div>
        <Typewrite examples={examples} />
        <hr className="border-neutral-300" />
      </div>
      <a
        href="mailto:office@budairallyacademy.ro?subject=Support Request&body=Hi, I have the following question..."
  className="w-full block text-center rounded-full border border-neutral-950 py-2 text-sm font-medium transition-colors hover:bg-neutral-950 hover:text-neutral-100"
      >
        {intl.formatMessage({ id: "footer.email" })}
      </a>

    </div>
  );
};

const LETTER_DELAY = 0.025;
const BOX_FADE_DURATION = 0.125;
const FADE_DELAY = 5;
const MAIN_FADE_DURATION = 0.25;
const SWAP_DELAY_IN_MS = 5500;

const Typewrite = ({ examples }) => {
  const [exampleIndex, setExampleIndex] = useState(0);
  const intl = useIntl();
  useEffect(() => {
    const intervalId = setInterval(() => {
      setExampleIndex((pv) => (pv + 1) % examples.length);
    }, SWAP_DELAY_IN_MS);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <p className="mb-[2vh] text-[clamp(12px, 2vw, 18px)] font-light uppercase">
      <span className="inline-block size-2 bg-neutral-950" />
      <span className="ml-[2vw]">
        {intl.formatMessage({ id: "footer.example" })}:{" "}
        {examples[exampleIndex].split("").map((l, i) => (
          <motion.span
            initial={{
              opacity: 1,
            }}
            animate={{
              opacity: 0,
            }}
            transition={{
              delay: FADE_DELAY,
              duration: MAIN_FADE_DURATION,
              ease: "easeInOut",
            }}
            key={`${exampleIndex}-${i}`}
            className="relative"
          >
            <motion.span
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: 1,
              }}
              transition={{
                delay: i * LETTER_DELAY,
                duration: 0,
              }}
            >
              {l}
            </motion.span>
            <motion.span
              initial={{
                opacity: 0,
              }}
              animate={{
                opacity: [0, 1, 0],
              }}
              transition={{
                delay: i * LETTER_DELAY,
                times: [0, 0.1, 1],
                duration: BOX_FADE_DURATION,
                ease: "easeInOut",
              }}
              className="absolute bottom-[3px] left-[1px] right-0 top-[3px] bg-neutral-950"
            />
          </motion.span>
        ))}
      </span>
    </p>
  );
};
